import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    paddingTop: "0px !important",
    "@media (orientation: landscape)": {
      height: "100% !important",
    },
  },
  content: {
    textAlign: "center",
    marginTop: theme.spacing.space24,
  },
  label: {
    margin: `${theme.spacing.space8}px 0px`,
  },
  exportIcon: {
    fontSize: "16px !important",
  },
  addIcon: {
    fontSize: "16px !important",
    marginLeft: theme.spacing.space2,
  },
}));
